require('./shopping-cart-indicator/shopping-cart-indicator.scss');
var BaseViews = require('../base');

var ShoppingCartIndicator = BaseViews.ItemView.extend({
    _expandedMap: false,
    template: require('./shopping-cart-indicator/shopping-cart-indicator.html'),
    className: 'fmcy-shopping-cart-indicator',
    ui: {
       cartCount: '.fmcy-shopping-cart-indicator-count'
    },
    events: {
      'click': 'onClick'
    },
    initialize: function (options) {
        var self = this;
        this.options = _.defaults(
            options || {},
            {
                _appChannel: null,
                _menuState: null,
                cartCount: 0,
                style: 'icon'
            }
        );
    },
    onClick: function () {
      this.options._appChannel.trigger('menu:overlay:view:close');
      this.options._appChannel.trigger('cart:view');
    },
    _updateCartCount: function (count) {
      // TODO: figure out why I need to check for JQUERY...
      if (this.ui.cartCount !== '.fmcy-shopping-cart-indicator-count') {
        if (count === 0) {
          this.ui.cartCount.hide();
        } else {
          this.ui.cartCount.show();
        }
        this.ui.cartCount.html(count);
      }
    },
    onRender: function () {
      var self = this;
      this._updateCartCount(this.options.cartCount);
      this.listenTo(this.options._appChannel, 'cart:items:updated', function () {
        if (self.rendered === true) {
          self._updateCartCount( self.options._appChannel.request('cart:get:items:count'));
        }
      });
      this.rendered = true;
    },
    serializeData: function () {
      var locationModel = this.options._appChannel.request('get:filter:location:details');
      return {
        style: this.options.style,
        locationName: locationModel.get('name')
      }
    }
});
module.exports = ShoppingCartIndicator;



/** WEBPACK FOOTER **
 ** ./assets/js/common/cart/shopping-cart-indicator.js
 **/